var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCirclePlusIconPassive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "14.5465mm",
    height: "14.547mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 128.79 128.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_983014106880"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "svgPassiveBorder",
    cx: 64.39,
    cy: 64.4,
    rx: 64.39,
    ry: 64.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "svgPassiveBg",
    cx: 64.39,
    cy: 64.4,
    r: 54.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "svgPassiveText",
    points: "57.74,97.4 57.74,71.05 31.39,71.05 31.39,57.75 57.74,57.75 57.74,31.39 71.05,31.39 71.05,57.75 97.4,57.75 97.4,71.05 71.05,71.05 71.05,97.4 "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlusIconPassive);
export default __webpack_public_path__ + "static/media/circlePlusIconPassive.83159a70.svg";
export { ForwardRef as ReactComponent };